import Title from '@Components/Title';
import { Notification, NotificationResponse } from '@Reducers/Notifications/Type';
import {
  downloadNotificationReportFile,
  getAllReadNotifications,
  getAllUnreadNotifications,
  putAllNotificationsRead,
  putNotificationReadById,
} from '@Reducers/Notifications/actions';
import { AppDispatch, RootStateType } from '@Store';
import CloseIcon from '@mui/icons-material/Close';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import {
  Box,
  Grow,
  IconButton,
  Paper,
  Stack,
  Tab,
  Typography,
  styled,
  useTheme,
  Fade,
  Zoom,
  Slide,
  alpha,
  useMediaQuery,
} from '@mui/material';
import Drawer from '@mui/material/Drawer';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
// import { onMessageListener } from '../../firebase';
import { userLogin } from '@Services/hasAdminAccess';
import SbButton from '@Components/Button';
import { setIsDrawerOpen } from '@Reducers/notificationState/notificationState';
import {
  FiberManualRecord as FiberManualRecordIcon,
  Download as DownloadIcon,
  Schedule as ScheduleIcon,
  Label as LabelIcon,
} from '@mui/icons-material';
dayjs.extend(relativeTime);

interface PropsType {
  icon: React.ReactNode;
}

type TabValues = 'unread' | 'all' | string;

const TABS: { label: string; value: string }[] = [
  {
    value: 'unread',
    label: 'Unread',
  },
  {
    value: 'all',
    label: 'All',
  },
];

const dateFormat = (apiDate: string) => {
  // Get the current date
  const currentDate = dayjs();

  // Convert the API date to dayjs object
  const apiDateObject = dayjs(apiDate);

  // Check if the API date is the same as the current date
  if (apiDateObject.isSame(currentDate, 'day')) {
    // If it's the same day, display "Today"
    return 'Today';
  } else {
    // If it's a different day, format and display the date
    const formattedDate = `${apiDateObject.format('DD/MM/YYYY')}, ${apiDateObject.format('dddd')}`; // You can customize the format
    return formattedDate;
  }
};

function Count({ icon }: PropsType) {
  const dispatch = useDispatch<AppDispatch>();
  const isDrawerOpen = useSelector((state: RootStateType) => state.notificationUI.isDrawerOpen);
  const [readCurrentPage, setReadCurrentPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [tabValue, setTabValue] = useState<TabValues>('unread');
  const { count, notifications, totalReadNotifications, readNotifications, limit } = useSelector(
    (state: RootStateType) => state.notifications,
  );
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const onTabChange = (_e: React.SyntheticEvent, currentTab: TabValues) => {
    setTabValue(currentTab);
  };

  useEffect(() => {
    dispatch(
      getAllUnreadNotifications({
        page: 1,
        limit,
      }),
    );
    dispatch(getAllReadNotifications({ page: 1, limit }));
  }, []);

  const handleOpenNotifications = () => {
    dispatch(setIsDrawerOpen(true));
    // dispatch(getAllUnreadNotifications());
  };

  //Notification Listener
  // onMessageListener(dispatch);

  useEffect(() => {
    if (readCurrentPage > 1) {
      dispatch(getAllReadNotifications({ page: 1, limit: limit * readCurrentPage }));
    }
  }, [readCurrentPage]);

  useEffect(() => {
    if (currentPage > 1) {
      dispatch(getAllUnreadNotifications({ page: 1, limit: limit * currentPage }));
    }
  }, [currentPage]);

  return (
    <>
      <Wrapper>
        <Box onClick={handleOpenNotifications} className="cursor-pointer">
          {icon}
          <span className="count">{count}</span>
        </Box>
      </Wrapper>
      <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={() => {
          dispatch(setIsDrawerOpen(false));
        }}
        variant="temporary"
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          '& .MuiBackdrop-root': {
            backdropFilter: 'blur(4px)',
            backgroundColor: 'rgba(0,0,0,0.35)',
          },

          '& .MuiDrawer-paper': {
            width: isSmallScreen ? '100%' : '30rem',
            backgroundImage: 'none',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
          },
        }}
      >
        <Box sx={{ width: { xs: '27rem', sm: '30rem' }, padding: '2rem 1rem 2rem 2rem', height: '100%' }}>
          <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} mb={1}>
            <Title title="Notifications" removeBorder removePadding />
            <IconButton
              sx={{
                fontSize: '1.5rem',
              }}
              onClick={() => dispatch(setIsDrawerOpen(false))}
            >
              <CloseIcon />
            </IconButton>
          </Stack>
          <TabContext value={tabValue}>
            <TabList
              onChange={onTabChange}
              indicatorColor="primary"
              TabIndicatorProps={{ sx: { height: '4px' } }}
              scrollButtons="auto"
              variant="scrollable"
              sx={{
                minHeight: '28px',
                mt: '1rem',
              }}
            >
              {TABS.map(cTab => (
                <Tab
                  sx={{ textTransform: 'none', padding: '0px 8px', minHeight: 'auto' }}
                  className="md-text font-medium sb-text-black"
                  value={cTab.value}
                  label={cTab.label}
                  key={cTab.value}
                />
              ))}
            </TabList>
            {/* {loading ? (
              <Stack justifyContent={'center'} alignItems={'center'} height={'80vh'}>
                <CircularProgress color="primary" />
              </Stack>
            ) : (
              <> */}
            <TabPanel value="unread" className="p-0 w-full">
              {notifications?.length > 0 && (
                <Stack direction={'row'} justifyContent={'flex-end'}>
                  <Typography
                    className="md-text font-medium underline cursor-pointer"
                    onClick={() => {
                      dispatch(putAllNotificationsRead());
                    }}
                  >
                    Clear All
                  </Typography>
                </Stack>
              )}
              <InfiniteScroll
                className="pr-4 fadedScroll mt-2"
                dataLength={notifications?.flatMap(data => data?.notifications).length}
                next={() => {
                  if (count > notifications?.flatMap(data => data?.notifications).length) {
                    setCurrentPage(prev => prev + 1);
                  }
                }}
                hasMore={count > notifications?.flatMap(data => data?.notifications).length}
                loader={<h4>Loading...</h4>}
                height={600}
                endMessage={
                  count > 0 && count === notifications?.flatMap(data => data?.notifications).length ? (
                    <p className="text-center mt-2">
                      <b>Yay! You have seen it all</b>
                    </p>
                  ) : (
                    <></>
                  )
                }
              >
                {notifications?.length > 0 ? (
                  notifications?.map((data: NotificationResponse) =>
                    data?.notifications?.map((notification: Notification) => (
                      <Card
                        key={notification?._id}
                        {...notification}
                        allowClose={true}

                        // borderColor=""
                      />
                    )),
                  )
                ) : (
                  <Stack justifyContent={'center'} alignItems={'center'} height={'60vh'}>
                    <Typography color={'primary.dark'} fontSize={'1.5rem'} variant="subtitle1">
                      Notifications not found
                    </Typography>
                  </Stack>
                )}
              </InfiniteScroll>
            </TabPanel>
            <TabPanel value="all" className="p-0 w-full">
              <InfiniteScroll
                className="pr-4 fadedScroll"
                style={{ overflow: 'hidden', overflowY: 'auto' }}
                dataLength={readNotifications?.flatMap(data => data?.notifications).length}
                next={() => {
                  if (totalReadNotifications > readNotifications?.flatMap(data => data?.notifications).length) {
                    setReadCurrentPage(prev => prev + 1);
                  }
                }}
                hasMore={totalReadNotifications > readNotifications?.flatMap(data => data?.notifications).length}
                loader={<h4>Loading...</h4>}
                height={640}
                endMessage={
                  totalReadNotifications > 0 &&
                  totalReadNotifications === readNotifications?.flatMap(data => data?.notifications).length ? (
                    <p className="text-center mt-2">
                      <b>Yay! You have seen it all</b>
                    </p>
                  ) : (
                    <></>
                  )
                }
              >
                {readNotifications?.length > 0 ? (
                  readNotifications?.map((data: NotificationResponse) => (
                    <div key={data?._id} className="mt-2">
                      <Typography color={'primary.dark'} fontWeight={600} variant="subtitle1">
                        {dateFormat(data?._id)}
                      </Typography>
                      {data?.notifications?.map((notification: Notification) => (
                        <Card
                          key={notification?._id}
                          {...notification}
                          allowClose={false}

                          // borderColor=""
                        />
                      ))}
                    </div>
                  ))
                ) : (
                  <Stack justifyContent={'center'} alignItems={'center'} height={'60vh'}>
                    <Typography color={'primary.dark'} fontSize={'1.5rem'} variant="subtitle1">
                      Notifications are not found!
                    </Typography>
                  </Stack>
                )}
              </InfiniteScroll>
            </TabPanel>
          </TabContext>
        </Box>
      </Drawer>
    </>
  );
}

function Card(
  props: Notification & {
    allowClose: boolean;
  },
) {
  const { title, createdAt, message, _id, data, allowClose } = props;
  const dispatch = useDispatch<AppDispatch>();
  const isUser = userLogin();
  const theme = useTheme();
  const [isHovered, setIsHovered] = useState(false);
  const [isExiting, setIsExiting] = useState(false);

  // Extract color based on notification type
  const getTypeColor = () => {
    switch (data?.type) {
      case 'shipment':
        return theme.palette.primary.main;
      case 'invoice':
        return theme.palette.secondary.main;
      case 'user':
        return theme.palette.success.main;
      case 'admin':
        return theme.palette.warning.main;
      default:
        return theme.palette.grey[500];
    }
  };

  const extractShipmentId = (message: any) => {
    const match = message.match(/You have been tagged in a new note on shipment (\d{12})/);
    return match ? match[1] : null;
  };

  const customUrl = () => {
    if (/http/.test(data?.url)) {
      return `${data?.url || ''}`;
    }

    if (title === 'You have been tagged in a new note') {
      return `/shipment/admin/edit/${extractShipmentId(message)}`;
    }
    if (/Status changed for Shipment Number (\d{12})/.test(title)) {
      const match = title.match(/Status changed for Shipment Number (\d{12})/);
      return `/track-shipment?trackingNumber=${match?.[1]}`;
    }
    if (/Shipment (\d{12}) has been cancelled!/.test(title)) {
      const match = title.match(/Shipment (\d{12}) has been cancelled!/);
      return `/track-shipment?trackingNumber=${match?.[1]}`;
    }
    if (/Shipment (\d{12}) Confirmed!/.test(title)) {
      const match = title.match(/Shipment (\d{12}) Confirmed!/);
      return isUser ? `/shipment/history/${match?.[1]}` : `/shipment/admin/edit/${match?.[1]}`;
    }
    if (title === 'Change in shipment charges') {
      const match = message.match(/shipment id (\d{12}) has been changed/);
      return match ? `/shipment/history/${match[1]}` : '';
    }

    if (title === 'New invoice generated.') {
      return '/invoice/list';
    }

    if (title === 'Bulk shipment summary') {
      return '/shipment/bulk-summary';
    }

    if (title === 'Bulk Upload Completed') {
      return '/shipment/bulk-summary';
    }

    if (/Payment for order ID (\d{12}) successfully completed\./.test(title)) {
      const match = title.match(/Payment for order ID (\d{12}) successfully completed\./);
      return `/track-shipment?trackingNumber=${match?.[1]}`;
    }

    if (title === 'Funds successfully deposited to your wallet.') {
      return '/transactions/wallet';
    }

    if (title === 'Credit limited updated') {
      return '/transactions/credit';
    }
    if (title === 'Credit limit exhausted!') {
      return '/transactions/credit';
    }

    if (title === 'Payment received') {
      const match = message.match(/Amount of (\d{12}) received for Order number\/invoice number/);
      return match ? `/shipment/history/${match[1]}` : '';
    }
    if (title === 'New credit note generated.' || title === 'New debit note generated.') {
      return '/invoice/list';
    }

    if (data?.type === 'user' || data?.type === 'admin' || data?.type === 'squad') {
      return `/profile`;
    }
    if (data?.type === 'shipment') {
      return isUser ? `/shipment/history/${data?.url || ''}` : `/shipment/admin/edit/${data?.url || ''}`;
    }
    if (data?.type === 'invoice') {
      return '/invoice/list';
    }
    return '';
  };

  const downloadReportFile = async (reportId: string) => {
    await dispatch(downloadNotificationReportFile(reportId));
  };

  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setIsExiting(true);
    // Small delay to allow exit animation
    setTimeout(() => {
      dispatch(putNotificationReadById(_id));
    }, 300);
  };

  // If exiting, don't render
  if (isExiting) return null;

  return (
    <Grow in={!isExiting} timeout={500}>
      <Link to={customUrl()} className="sb-text-black text-decoration-none" style={{ display: 'block' }}>
        <Paper
          elevation={isHovered ? 3 : 1}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          sx={{
            position: 'relative',
            overflow: 'hidden',
            transition: theme.transitions.create(['box-shadow', 'transform'], {
              duration: theme.transitions.duration.shorter,
            }),
            transform: isHovered ? 'translateY(-2px)' : 'none',
            borderRadius: 2,
            mb: 2,
            border: '1px solid',
            borderColor: alpha(getTypeColor(), 0.2),
            '&::before': {
              content: '""',
              position: 'absolute',
              left: 0,
              top: 0,
              bottom: 0,
              width: 4,
              background: `linear-gradient(180deg, ${getTypeColor()} 0%, ${alpha(getTypeColor(), 0.6)} 100%)`,
              transition: theme.transitions.create('width', {
                duration: theme.transitions.duration.shorter,
              }),
            },
            '&:hover::before': {
              width: 6,
            },
          }}
        >
          <Box sx={{ p: 2, pl: 3 }}>
            {/* Header Section */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                mb: 1,
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Fade in timeout={1000}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 0.5,
                      backgroundColor: alpha(getTypeColor(), 0.1),
                      color: getTypeColor(),
                      px: 1,
                      py: 0.5,
                      borderRadius: 1,
                    }}
                  >
                    <LabelIcon sx={{ fontSize: 12 }} />
                    <Typography
                      variant="caption"
                      sx={{
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        letterSpacing: 0.5,
                      }}
                    >
                      {data?.type}
                    </Typography>
                  </Box>
                </Fade>

                {allowClose && (
                  <Zoom in timeout={500}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <FiberManualRecordIcon
                        sx={{
                          fontSize: 8,
                          color: alpha(theme.palette.text.secondary, 0.3),
                        }}
                      />
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <ScheduleIcon sx={{ fontSize: 14, color: theme.palette.text.secondary }} />
                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                          {dayjs(createdAt)?.fromNow()}
                        </Typography>
                      </Box>
                    </Box>
                  </Zoom>
                )}
              </Box>

              {allowClose && (
                <Slide direction="left" in timeout={500}>
                  <IconButton
                    size="small"
                    onClick={handleClose}
                    sx={{
                      color: theme.palette.text.secondary,
                      transition: theme.transitions.create(['background-color', 'color'], {
                        duration: theme.transitions.duration.shorter,
                      }),
                      '&:hover': {
                        backgroundColor: alpha(theme.palette.error.main, 0.1),
                        color: theme.palette.error.main,
                      },
                    }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Slide>
              )}
            </Box>

            {/* Title Section */}
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 600,
                mb: 0.5,
                color: theme.palette.text.primary,
                transition: theme.transitions.create('color', {
                  duration: theme.transitions.duration.shorter,
                }),
                ...(isHovered && {
                  color: getTypeColor(),
                }),
              }}
            >
              {title}
            </Typography>

            {/* Message Section */}
            <Typography
              variant="body2"
              component="div"
              sx={{
                color: theme.palette.text.secondary,
                lineHeight: 1.6,
                '& p': { mb: 1 },
                '&:last-child': { mb: 0 },
              }}
              dangerouslySetInnerHTML={{
                __html: message.replace(/\n/g, '<br/>'),
              }}
            />

            {/* Download Button Section */}
            {data?.reportId && (
              <Fade in timeout={1000}>
                <Box sx={{ mt: 2 }}>
                  <SbButton
                    variant="outlined"
                    size="small"
                    startIcon={<DownloadIcon />}
                    onClick={e => {
                      e.stopPropagation();
                      e.preventDefault();
                      if (data?.reportId) {
                        downloadReportFile(data?.reportId);
                      }
                    }}
                    sx={{
                      borderColor: alpha(theme.palette.primary.main, 0.3),
                      color: theme.palette.primary.main,
                      transition: theme.transitions.create(['background-color', 'border-color', 'transform'], {
                        duration: theme.transitions.duration.shorter,
                      }),
                      '&:hover': {
                        borderColor: theme.palette.primary.main,
                        backgroundColor: alpha(theme.palette.primary.main, 0.05),
                        transform: 'scale(1.02)',
                      },
                      '&:active': {
                        transform: 'scale(0.98)',
                      },
                    }}
                  >
                    Download Report
                  </SbButton>
                </Box>
              </Fade>
            )}
          </Box>
        </Paper>
      </Link>
    </Grow>
  );
}

export default Count;

const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '44px',
  width: '44px',
  backgroundColor: '#f4f3f7',
  borderRadius: '12px',
  marginRight: '10px',
  position: 'relative',
  '& .count': {
    position: 'absolute',
    right: '2px',
    bottom: '5px',
    background: theme.palette.secondary.main,
    height: '20px',
    padding: '0 5px',
    borderRadius: '50px',
    color: theme.palette.primary.contrastText,
  },
}));
